import type { Store } from '@reduxjs/toolkit';
import { useDispatch, useSelector, useStore } from 'react-redux';

/** `export const { useAppDispatch, useAppSelector, useAppStore } = appHooks<AppStore>()`. */
export const appHooks = <S extends Store>() => ({
  useAppDispatch: useDispatch.withTypes<S['dispatch']>(),
  useAppSelector: useSelector.withTypes<ReturnType<S['getState']>>(),
  useAppStore: useStore.withTypes<S>(),
});
